import { css } from '@emotion/react';

export const selectedValueStyles = {
    root: css({
        display: 'flex',
        alignItems: 'center',
        color: '#000',
        fontSize: '12px',
        fontWeight: '600',
        padding: '8px',
        borderRadius: '3px',
        backgroundColor: '#DAE7FA',
        cursor: 'pointer',
        maxWidth: 'fit-content',
    }),
    quickFilterSelected: css({
        paddingRight: '4px',
    }),
    unselected: css({
        backgroundColor: '#EDEDED',
    }),
    closeIcon: css({
        width: '16px',
        height: '16px',
        marginLeft: '5px',
    }),
    innerContainer: css({
        display: 'flex',
        alignItems: 'center',
        gap: '2px',
    }),
    quickFilter: css({
        fontWeight: '700',
        fontSize: '10px',
        padding: '13px 10px',
    }),
};
